var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 58,
    viewBox: "0 0 187 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_38)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9971 36.9924V10.1516L107.498 36.9924H124.087V0.36377H110.603V28.2961L85.7249 0.36377H70.1629V36.9924H83.9971Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187 36.9924V30.1033H152.782C147.249 30.1033 147.949 26.8407 147.949 24.3058V14.8818C147.949 12.3469 147.26 7.99271 152.782 7.26499H187V0.36377H145.171C135.843 0.36377 130.998 9.43602 130.998 19.2239C130.998 29.0117 134.454 36.9924 144.821 36.9924H186.988H187Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9005 37.3563C3.80584 37.3563 0 28.6601 0 19.224C0 9.07225 5.53365 0 16.2507 0H61.1854V6.88909H22.8117C16.9395 7.98067 17.2781 11.971 17.2781 14.5059L17.6283 23.9299C17.6283 26.4648 16.9395 31.1828 22.8117 30.819H44.5844C46.3122 30.0913 48.04 27.9202 48.04 26.1009V22.4744H31.4507V15.9492H61.1737V37.3442H15.9005V37.3563Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.90691 43.36H5.34686V55.8526H14.3945V57.5385H2.90691V43.3479V43.36Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0298 43.3601H27.4931V57.5507H25.0298V43.3601Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4554 43.3601L43.6388 55.4403L48.7638 43.3601H51.5073L44.923 57.5507H42.3313L35.7586 43.3601H38.4554Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3758 43.36H72.4628V45.0944H61.7574V49.4H71.6573V51.0374H61.7574V55.8404H72.6496V57.5262H59.3758V43.3357V43.36Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.345 43.3601L104.742 54.8824L108.817 43.3601H111.455L115.541 54.9066L118.938 43.3601H121.612L116.872 57.5507H114.304L110.136 45.7858L105.945 57.5507H103.377L98.6601 43.3601H101.31H101.345Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.998 43.36H144.085V45.0944H133.38V49.4H143.28V51.0374H133.38V55.8404H144.272V57.5262H130.998V43.3357V43.36Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.249 43.36H155.689V55.8526H164.737V57.5385H153.238V43.3479L153.249 43.36Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.193 43.36H176.633V55.8526H185.681V57.5385H174.182V43.3479L174.193 43.36Z",
    fill: "#E30613"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 57.5385,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGns);
export default __webpack_public_path__ + "static/media/GNS.556915c9563b735322ec5dabedca38a0.svg";
export { ForwardRef as ReactComponent };